import styled from "styled-components";

export const StyledPeriodSelector = styled.div`
  .period-selector {
    display: flex;
    background-color: #fff;
    border: 1px solid #d2d2d2;
    border-radius: 4px;
    overflow: hidden;
    & > button {
      width: 72px;
      border: none;
      padding: 6px 16px;
      color: #777;
      border-right: 1px solid #d2d2d2;
      background-color: #fff;
      cursor: pointer;
      font-size: 14px;
      font-weight: 200;
      &:last-child {
        border: none;
      }
      &.active {
        box-shadow: inset 0px 3px 5px 0px rgba(0, 0, 0, 0.15);
      }
      &:hover {
        background-color: #b7b7b750;
      }
    }
  }
`;
